// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ECVh","field":"styles_field__RDfXS","fieldCol":"styles_fieldCol__1IZHh","diffCol":"styles_diffCol__3PSaA","diff":"styles_diff__2gTVn"};